import { BadgeType } from '@@/Badge';

import { AlertRuleRow } from './types';

export function severityToBadgeType(
  severity: AlertRuleRow['severity']
): BadgeType {
  switch (severity) {
    case 'critical':
      return 'danger';
    case 'warning':
      return 'warn';
    case 'info':
    default:
      return 'info';
  }
}
